import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useGetCompanyAttributes = (companyId: number) => {
  const call = useCallback(async () => {
    if (companyId) {
      const { data } = await axiosInstance.get<string[]>(api.getCompanyAttributes(companyId));
      return data;
    }
  }, [companyId]);

  const { execute, isLoading } = useAsync(call, false, []);
  return {
    getCompanyAttributes: execute,
    isLoading,
  };
};

export default useGetCompanyAttributes;
